import { useQuery } from '@tanstack/react-query'
import { useAnalytics } from 'utils/analytics'
import { fetchItemDetails } from 'queries/item-details/item-details'
import { QueryKeys } from 'constants/query-keys'
import { ItemDetailsFetchProps } from 'types/api'

export function useItemDetails({
    env,
    accessToken,
    location,
    filters,
}: ItemDetailsFetchProps) {
    const { trackEvent } = useAnalytics()
    const isEnabled =
        (filters?.location_id.length ?? 0) > 0 &&
        (filters?.item_id.length ?? 0) > 0

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.ITEM_DETAILS, filters?.item_id, location],
        () =>
            fetchItemDetails({
                env,
                accessToken,
                location,
                filters,
                trackEvent,
            }),
        {
            enabled: isEnabled,
            staleTime: 0,
            cacheTime: 0,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
